import { gql } from '@apollo/client'

export const CREATE_CITY = gql`
  mutation createCity($input: CreateCityInput!) {
    data: createCity(input: $input) {
      id
    }
  }
`
